import React from 'react';

interface IPrideleneIsin {}

const PrideleneIsin: React.FC<IPrideleneIsin> = () => {
    return <></>;
};

export default PrideleneIsin;
